/**
 * These are the keys for the information **modals**.
 *
 * It is different from the `SpotlightKey` enum, because the Spotlights
 * are only shown once, but these modals can be shown anytime and may not have
 * a one-to-one equivalent in `SpotlightKey`.
 */
export enum InfoModalKey {
	/**
	 * We ask the user's location
	 */
	LOCATION = 'LOCATION',

	/**
	 * The user opens the lateral menu to change workspace.
	 */
	CHANGE_WORKSPACE = 'CHANGE_WORKSPACE',

	/**
	 * The user navigates to a node.
	 */
	NODE_INFO_INITIAL = 'NODE_INFO_INITIAL',

	/**
	 * The user navigates to the properties section in `node info`.
	 */
	NODE_INFO_PROPERTIES = 'NODE_INFO_PROPERTIES',

	/**
	 * The user navigates to the relationships section in `node info`.
	 */
	NODE_INFO_RELATIONSHIPS = 'NODE_INFO_RELATIONSHIPS',

	/**
	 * The info button on recommendations
	 */
	NODE_INFO_RECOMMENDATIONS = 'NODE_INFO_RECOMMENDATIONS',

	/**
	 * The `property filter` section in the advanced search.
	 */
	SEARCH_PROPERTIES_FILTER = 'SEARCH_PROPERTIES_FILTER',

	/**
	 * The `nodes filter` section in the advanced search.
	 */
	SEARCH_NODES_FILTER = 'SEARCH_NODES_FILTER',

	/**
	 * The `nodes to exclude` section in the advanced search.
	 */
	SEARCH_NODES_TO_EXCLUDE_FILTER = 'SEARCH_NODES_TO_EXCLUDE_FILTER',

	/**
	 * The `Nodes Filter Options` section in the advanced search (in common, all, etc).
	 */
	SEARCH_NODES_OPERATOR = 'SEARCH_NODES_OPERATOR',

	/**
	 * The `workspaces filter` section in the advanced search.
	 */
	SEARCH_WORKSPACES_FILTER = 'SEARCH_WORKSPACES_FILTER',

	/**
	 * The user selects the `visualiser` option in `change-view`.
	 */
	SEARCH_VIEW_VISUALISER = 'SEARCH_VIEW_VISUALISER',

	/**
	 * The user selects the `board` option in `change-view`.
	 */
	SEARCH_VIEW_BOARD = 'SEARCH_VIEW_BOARD',

	/**
	 * The user selects the `list` option in `change-view`.
	 */
	SEARCH_VIEW_LIST = 'SEARCH_VIEW_LIST',
	/**
	 * The user selects the `table` option in `change-view`.
	 */
	SEARCH_VIEW_TABLE = 'SEARCH_VIEW_TABLE',

	/**
	 * The user selects the `big image` option in `change-view`.
	 */
	SEARCH_VIEW_BIG_IMAGE = 'SEARCH_VIEW_BIG_IMAGE',

	/**
	 * The user clicks on the info button in the tag types info page's smart features section.
	 */
	TAG_TYPES_SMART_FEATURES = 'TAG_TYPES_SMART_FEATURES',

	/**
	 * The user clicks on the smart features info button in the websites settings page.
	 */
	SF_WEBSITE_SETTINGS = 'SF_WEBSITE_SETTINGS',

	NODE_CREATION_WORKSPACE_SELECTOR = 'NODE_CREATION_WORKSPACE_SELECTOR',
	NODE_CREATION_TAG = 'NODE_CREATION_TAG',
	NODE_CREATION_NOTE = 'NODE_CREATION_NOTE',
	NODE_CREATION_WEBSITE = 'NODE_CREATION_WEBSITE',
	NODE_CREATION_FILE = 'NODE_CREATION_FILE',
	NODE_CREATION_WORKSPACE = 'NODE_CREATION_WORKSPACE',

	INTEGRATIONS_FIRST_TIME = 'INTEGRATIONS_FIRST_TIME',

	/**
	 * Misc
	 */
	CHAT_AI_LEARN_ALL = 'CHAT_AI_LEARN_ALL',
	CHAT_AI_HOW_IT_WORKS = 'CHAT_AI_HOW_IT_WORKS',
}
